import Topp from '../../assets/svgs/folder/topp.svg'
import Bottom from '../../assets/svgs/folder/botten.svg'
import styles from './Folder.module.scss'

const Folder = ({ children }) => {
  return (
    <div className={styles.folder}>
      <div className={styles.top}>
        <img src={Topp} alt="topp" />
      </div>
      <div
        className={styles.mainContent}
        style={{
          background: 'url("./images/folder/mitt.svg")',
        }}
      >
        {children}
      </div>
      <div className={styles.bottom}>
        <img src={Bottom} alt="bottom" />
      </div>
      <div className={styles.bottom} />
    </div>
  )
}

export default Folder
